import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Row } from "antd";
import { fetchTaskById } from "../../store/slices/tasks";
import SubtasksTableContainer from "../SubtasksTableContainer/SubtasksTableContainer";

interface ITaskDetalizationContainer {
  setIsModalConfirmationVisible: () => void;
  setTaskIdForReprocess: () => void;
  runReprocessTask: any;
}

function TaskDetalizationContainer(props: ITaskDetalizationContainer) {
  const { setIsModalConfirmationVisible, setTaskIdForReprocess } = props;
  const dispatch = useDispatch();
  // @ts-ignore
  const { taskId } = useParams();
  const history = useHistory();

  const [subTasksCurrentPage, setSubTasksCurrentPage] = useState(1);

  useEffect(() => {
    // @ts-ignore
    dispatch(fetchTaskById({ taskId, includeChildren: false }));
  }, [dispatch, taskId]);

  return (
    <div style={{ padding: 10 }}>
      <SubtasksTableContainer
        taskId={taskId}
        subtasksStatusForFetching={0}
        setTaskIdForReprocess={setTaskIdForReprocess}
        setIsModalConfirmationVisible={setIsModalConfirmationVisible}
        subTasksCurrentPage={subTasksCurrentPage}
        setSubTasksCurrentPage={setSubTasksCurrentPage}
      />
      <Row justify="center" style={{ marginTop: "25px" }}>
        <Button style={{ width: "100px" }} onClick={() => history.push("/tasks")}>
          Назад
        </Button>
      </Row>
    </div>
  );
}

export default TaskDetalizationContainer;
